import { AddToCartItem } from '@/modules/models';
import { isInShopify } from '@/utils';
import request from './data/request';
import * as types from './types';

const SHOPIFY_API_BASE_URL = window.location.origin;

export const getShopifyCart = () => {
  if (!isInShopify()) {
    // we're not in scope of Shopify theme - do nothing
    return Promise.resolve(null);
  }
  const url = `${SHOPIFY_API_BASE_URL}/cart.json`;
  return request.get<types.ShopifyCart | null>(url);
};

export const getToken = (params: types.GetToken) =>
  request.get<{ id_token: string; chat_id?: number }>('/jwt', params, { skipToken: true });

export const reOpenChat = (params: types.ReOpenChatParams) =>
  request.get<{ id_token: string; chat_id: number }>('/jwt/reopen', params, { skipToken: true });

export const getProducts = (productId: string) => {
  if (!isInShopify()) {
    // we're not in scope of Shopify theme - do nothing
    return null;
  }
  const url = `${SHOPIFY_API_BASE_URL}/products/${productId}.js`;
  return request.get<{ variants: { id: string }[] }>(url);
};

interface AddProductToCartProps {
  variantId: string;
  quantity: number;
  params?: { [key: string]: any };
  lineItemProperties?: AddToCartItem['line_item_properties'];
  sellingPlan?: string;
}

export const addProductToCart = async ({
  variantId,
  quantity,
  params,
  lineItemProperties,
  sellingPlan,
}: AddProductToCartProps) => {
  if (!isInShopify()) {
    // we're not in scope of Shopify theme - do nothing
    return null;
  }

  const url = `${SHOPIFY_API_BASE_URL}/cart/add.js`;
  const properties = lineItemProperties?.length
    ? Object.fromEntries(lineItemProperties.map(({ label, value }) => [label, value]))
    : undefined;
  return request.post(url, {
    id: variantId,
    quantity: quantity.toString(),
    selling_plan: sellingPlan,
    ...params,
    ...(properties && { properties }),
  });
};

export const addShopifyEvent = (params: types.AddShopifyEventType) => request.post('/shopify/events', params);

// TODO: once BE is ready, replace with different endpoint
export const addEvent = (params: types.AddEventType) => request.post('/shopify/events', params);

export const chatRate = (params: types.ChatRateType) => request.post('/chats/rate', params);

export const messages = (params: types.MessagesType) => request.post('/messages', params);

export const viewHistory = (params: types.ViewHistoryType) => request.post('/view-history', params);

export const updateSessionShopify = (params: types.SessionData) => request.put('/shopify/sessions/update', params);

export const getLiveAgentAvailability = () => request.get<{ is_available: boolean }>('/chat/live-agent/availability');

export const preloadAttachments = (formData: FormData) =>
  request.upload<types.PreloadAttachmentsResponse>('/shopify/attachments', formData);
